<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableElasticsearchResourceListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableElasticsearchResourceVue = {};
export default {
  name: "TableElasticsearchResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountNameSearchIDVal: "",
      columns: [
        {
          title: this.$t("RAM.AWS.Elasticsearch.accountName"),
          minWidth: 150,
          fixed: "left",
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.accountID"),
          minWidth: 150,
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.region"),
          minWidth: 150,
          key: "region"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.domainName"),
          minWidth: 150,
          key: "domainName"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.elasticsearchVersion"),
          minWidth: 150,
          key: "elasticsearchVersion"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.instanceType"),
          minWidth: 150,
          key: "instanceType"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.instanceCount"),
          minWidth: 150,
          key: "instanceCount"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.volumeType"),
          minWidth: 150,
          key: "volumeType"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.volumeSize"),
          minWidth: 150,
          key: "volumeSize"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.dedicatedMasterType"),
          minWidth: 150,
          key: "dedicatedMasterType"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.dedicatedMasterCount"),
          key: "dedicatedMasterCount",
          minWidth: 150,
          fixed: "right"
        }
        // {
        //     title: '快照',
        //     key: 'addressSpace'
        // }
      ],
      tableElasticsearchResourceListData: []
    };
  },
  beforeCreate: function() {
    tableElasticsearchResourceVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("accountNameSearchID", function(accountNameSearchIDVal) {
      tableElasticsearchResourceVue.accountNameSearchIDVal = accountNameSearchIDVal;
    }),
      eventBus.$on("companyId", function(val) {
        tableElasticsearchResourceVue.companyId = val;
      }),
      eventBus.$on("domainName", function(val) {
        tableElasticsearchResourceVue.domainName = val;
      });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableElasticsearchResourceVue.getElasticsearchResourceListData();
    },
    // 分页显示数据
    /****************************************************/
    getElasticsearchResourceListData: function() {
      this.$api.resourceManagement
        .selectAWSElasticsearchByPage({
          domainName: tableElasticsearchResourceVue.domainName,
          accountName: tableElasticsearchResourceVue.accountNameSearchIDVal,
          companyId: tableElasticsearchResourceVue.companyId,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableElasticsearchResourceListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableElasticsearchResourceVue.getElasticsearchResourceListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableElasticsearchResourceVue.getElasticsearchResourceListData();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/elasticsearch/TableElasticsearchResource.vue